<template src="./TwoFactorActivation.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import AuthCard from "@/components/AuthCard";
import TwoFactorForm from "@/components/TwoFactorForm";
import BaseDialog from "@/components/BaseDialog";
import logo from "@/assets/img/BMW_logo_(white).svg";
import playStoreLogo from "@/assets/img/play_store.png";
import appStoreLogo from "@/assets/img/app_store.png";
import { accountModule } from "@/store/modules/account";
import { AccountActions } from "@/store/modules/account/actions";
import { AccountGetters } from "@/store/modules/account/getters";
import Errors from "./BackendResponseErrors.json";
import { Routes } from "@/router/routes";
import { notificationsModule } from "@/store/modules/notifications";
import { NotificationsActions } from "@/store/modules/notifications/actions";

export default defineComponent({
    components: { AuthCard, TwoFactorForm, BaseDialog },
    computed: {
        ...accountModule.mapGetters({
            loading: AccountGetters.Loading,
            errors: AccountGetters.Errors
        })
    },
    methods: {
        ...accountModule.mapActions({
            getTwoFactorSetupCode: AccountActions.GetTwoFactorSetupCode,
            activateTwoFactor: AccountActions.ActivateTwoFactorAuthentication,
            verifyLogin: AccountActions.VerifyLogin
        }),
        ...notificationsModule.mapActions({
            showError: NotificationsActions.NotifyError
        }),
        async submit(twoFactorPassword: string): Promise<void> {
            const token = this.$route.query.token as string;
            await this.activateTwoFactor({ token, code: twoFactorPassword });
            await this.verifyLogin();
            this.successPopupVisible = true;
        },
        async getQrCodeData(): Promise<string> {
            const token = this.$route.query.token as string;
            const data = await this.getTwoFactorSetupCode(token);
            return data;
        },
        goToLoginPage(): void {
            this.$router.push(Routes.Login);
        },
        onSuccess(): void {
            this.$router.push(
                (this.$route.query.redirecturl as string) ?? Routes.Home
            );
        }
    },
    data() {
        return {
            logo,
            appStoreLogo,
            playStoreLogo,
            tokenErrorPopupVisible: false,
            successPopupVisible: false
        };
    },
    watch: {
        errors(errors: string[] | null) {
            if (!errors) return;
            if (errors[0].includes(Errors.BadRequest.Error)) {
                this.showError(Errors.BadRequest.Message);
            } else {
                this.showError(errors[1] ?? Errors.Default.Message);
            }
        }
    },
    mounted() {
        this.getQrCodeData()
            .then((data) => {
                const qrCodeImageElement = document.getElementById(
                    "qrCode"
                ) as HTMLImageElement;
                qrCodeImageElement.src = data;
            })
            .catch(() => (this.tokenErrorPopupVisible = true));
    }
});
</script>

<style src="./TwoFactorActivation.scss" lang="scss" scoped></style>
